import React from "react";
import CheckboxIcon from "../CheckboxIcon/CheckboxIcon";
import "./Checkbox.css";

const Checkbox = (props) => {
  return (
    <label className="checkbox-label" htmlFor={props.value + "_" + props.id}>
      <CheckboxIcon isChecked={props.isChecked} />
      <input
        type="checkbox"
        id={props.value + "_" + props.id}
        readOnly={true}
        name={props.name}
        value={props.value}
        checked={props.isChecked}
        onChange={(e) => props.onChange(e)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          e.nativeEvent.stopPropagation();
        }}
      />
      {props.value}
    </label>
  );
};

export default Checkbox;
